import { render } from "./CaseBuddyValueThreadPanel.vue?vue&type=template&id=5486269d&scoped=true"
import script from "./CaseBuddyValueThreadPanel.vue?vue&type=script&lang=js"
export * from "./CaseBuddyValueThreadPanel.vue?vue&type=script&lang=js"

import "./CaseBuddyValueThreadPanel.vue?vue&type=style&index=0&id=5486269d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5486269d"]])

export default __exports__